import { useEffect } from 'react';
import './Pagination.css';

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

/** Query string for a paged list request; pageSize 0 means "All" (no paging). */
export function pagingParams(page, pageSize) {
  return pageSize ? `page=${page}&limit=${pageSize}` : '';
}

/**
 * Pager for server-paged lists: range summary, rows-per-page select, previous / next.
 * pageSize 0 = show all.
 */
export default function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  const totalPages = pageSize ? Math.max(1, Math.ceil(total / pageSize)) : 1;

  // If rows disappear (approve, delete, resolve) and the current page is now past the end, step back.
  useEffect(() => {
    if (page > totalPages) onPageChange(totalPages);
  }, [page, totalPages, onPageChange]);

  if (!total) return null;

  const from = pageSize ? (page - 1) * pageSize + 1 : 1;
  const to = pageSize ? Math.min(page * pageSize, total) : total;

  return (
    <nav className="pager" aria-label="Pagination">
      <p className="pager-summary">
        Showing {from}–{to} of {total}
      </p>
      <label className="pager-size">
        Rows per page
        <select
          className="pager-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
          <option value={0}>All</option>
        </select>
      </label>
      <div className="pager-nav">
        <button
          type="button"
          className="pager-btn"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
        >
          ← Previous
        </button>
        <span className="pager-page" aria-live="polite">
          Page {page} of {totalPages}
        </span>
        <button
          type="button"
          className="pager-btn"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
        >
          Next →
        </button>
      </div>
    </nav>
  );
}
